import React, { useCallback, useEffect, useState } from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import { getPlatformFunnel } from '../../services/api';

const STAGE_LABELS = {
  landing_view: 'Заход на лендинг',
  signup_started: 'Открыли форму регистрации',
  signup_completed: 'Зарегистрировались',
  iiko_connected: 'Подключили iiko',
  payment_succeeded: 'Оплатили',
};

// Простая воронка без графиков (как и весь остальной /platform) — числа по
// стадиям плюс % от предыдущей. landing_view/signup_started считаются по
// анонимным событиям с лендинга (см. /api/track), остальные пишет сам сервер.
const FunnelCard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await getPlatformFunnel(30));
      setError('');
    } catch (e) {
      setError('Не удалось загрузить воронку');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <section className="ui-card">
      <div className="ui-card-head">
        <h2>Воронка</h2>
        <p>Лендинг → регистрация → подключение iiko → оплата, за последние {data?.days || 30} дней.</p>
      </div>

      {loading && <LoadingSpinner />}
      {!loading && error && <div className="ui-inline-error">{error}</div>}
      {!loading && !error && data && (
        <div className="platform-funnel">
          {data.stages.map((stage, i) => {
            const prev = i > 0 ? data.stages[i - 1].count : null;
            const pct = prev ? Math.round((stage.count / prev) * 100) : null;
            return (
              <div className="platform-funnel-row" key={stage.event}>
                <span className="platform-funnel-label">{STAGE_LABELS[stage.event] || stage.event}</span>
                <span className="platform-funnel-count">{stage.count}</span>
                <span className="ui-dim">{pct !== null ? `${pct}% от предыдущего шага` : ''}</span>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default FunnelCard;
